import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

let guardDog = [
  new Dialog(
    "GUARD DOG: * Vicious Dog Noises *.",
    require("@/images/Dog_Angry.png"),
    require("@/audio/Pandemic-37-Dog-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Uggh, I should have known Dareth Schamren would have an ugly guard dog lying around.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-37-Sonny-MP3.mp3")
  ),
];

let intimidateGuardDog = [
  new Dialog(
    "SONNY YANG: You may be putting on quite the front, but I know that deep down, you’re more afraid of me than I am of you...",
    require("@/images/Dog_Angry.png"),
    require("@/audio/Pandemic-38-Sonny-MP3.mp3")
  ),
  new Dialog(
    "",
    require("@/images/Finger.png"),
    require("@/audio/flipoff.mp3")
  ),
  new Dialog(
    "[DARETH JUNIOR THE GUARD DOG ATTACKS YOU!]",
    require("@/images/Dog_Attack.png"),
    require("@/audio/Pandemic-37-Dog-MP3.mp3")
  ),
];

let distractGuardDogWithoutBurger = [
  new Dialog(
    "SONNY YANG: Look over there Doggy! A juicy looking cat!",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-39-Sonny-MP3.mp3")
  ),
  new Dialog(
    "[DARETH JUNIOR THE GUARD DOG ATTACKS YOU!]",
    require("@/images/Dog_Attack.png"),
    require("@/audio/Pandemic-37-Dog-MP3.mp3")
  ),
];

let distractGuardDogWithBurger = [
  new Dialog(
    "SONNY YANG: A flame - grilled patty on a soft sesame seed bun, with juicy tomatoes, creamy mayonnaise and mouth - watering lettuce.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-40-Sonny-MP3.mp3")
  ),
  new Dialog(
    "[USED 1 X BURGER]",
    require("@/images/Burger.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "You tame GUARD DOG DARETH JUNIOR!",
    require("@/images/Dog_Tamed.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class GuardDog extends Scene {
  image = require("@/images/Dareths_Front_Yard.png");
  title = "Dareth's Guard Dog";

  async init() {
    await this.dialogRunner(guardDog);
  }

  get options(): any[] {
    return [
      new Choice("Intimidate Dog", async () => {
        await this.dialogRunner(intimidateGuardDog)
        await this.navigate(scenes.EmergencyRoom())
      }),
      new Choice("Distract Dog", async () => {
        if (this.state.inventory.burger.has) {
          await this.dialogRunner(distractGuardDogWithBurger),
            this.state.storylines.dogHasBeenTamed = true;
          this.state.inventory.burger.has = false;
          await this.navigate(scenes.FrontDoor());
        } else {
          await this.dialogRunner(distractGuardDogWithoutBurger)
          await this.navigate(scenes.EmergencyRoom())
        }
      }),
      new Choice("Run away", async () => await this.navigate(scenes.DarethsYard())),
    ];
  }
}

export default new GuardDog();
